import { Lock } from "@phosphor-icons/react";
import { cn } from "@reactive-resume/utils";
import { Tooltip } from "@reactive-resume/ui";
import { useBreakpoint } from "@reactive-resume/hooks";

import { useCoverLetterStore } from "@/client/stores/cover-letter";
import { useBuilderStore } from "@/client/stores/builder";
import { useSaveStatusStore } from "@/client/stores/useSaveStatusStore";

import { SaveStatusBadge } from "../../builder/_components/SavingIndicator";

export const CoverLetterBuilderHeader = () => {
  const { isDesktop } = useBreakpoint();

  const title = useCoverLetterStore((state) => state.coverLetter?.title ?? "");
  const locked = useCoverLetterStore((state) => state.coverLetter?.locked);

  const isDragging = useBuilderStore(
    (state) => state.panel.left.handle.isDragging || state.panel.right.handle.isDragging,
  );
  const leftPanelSize = useBuilderStore((state) => state.panel.left.size);
  const rightPanelSize = useBuilderStore((state) => state.panel.right.size);

  const status = useSaveStatusStore((s) => s.status);

  return (
    <div
      style={{ left: `${leftPanelSize}%`, right: `${rightPanelSize}%` }}
      className={cn(
        "fixed inset-x-0 top-0 z-[60] h-[3rem] bg-neutral-100 backdrop-blur-lg lg:z-20",
        !isDragging && "transition-[left,right]",
      )}
    >
      <div className="flex h-full w-full items-center">
        <div className="mx-auto flex w-full items-center justify-between px-4">
          <div className="flex w-full items-center justify-center gap-x-2 lg:mx-auto">
            <h1 className="w-max font-medium">
              {!isDesktop && title.length > 35 ? title.slice(0, 35) + "..." : title}
            </h1>
            {locked && (
              <Tooltip content="This cover letter is locked, please unlock to make further changes.">
                <Lock size={14} className="ml-2 opacity-75" />
              </Tooltip>
            )}
          </div>
          <div className="mr-2 flex w-full items-center justify-end">
            <SaveStatusBadge status={status} />
          </div>
        </div>
      </div>
    </div>
  );
};
